import type { MedplumClient } from '@medplum/core';
import type { Practitioner } from '@medplum/fhirtypes';
import { practitionerBelongsToOrganization } from '../../../lib/adminDirectoryMapping';
import { EXTENSION_URLS } from '../../../features/rbac/constants';
import { PROVIDER_ROLES, type Role } from '../../users/types/rbac';
import { practitionerToIntakeProvider } from './intakeFhirMapping';
import type { MockProvider } from './mockProviders';

function isProviderRole(p: Practitioner): boolean {
  const role = p.extension?.find((e) => e.url === EXTENSION_URLS.role)?.valueString;
  // Missing role extension defaults to provider, matching practitionerToUser in the admin directory.
  if (!role) return true;
  return PROVIDER_ROLES.includes(role as Role);
}

/**
 * Providers linked to the practice — used for staff manual provider pick.
 *
 * Practice membership is the `unify.health/fhir/organization` extension on Practitioner
 * (same model as the Settings → Users directory); the app does not create PractitionerRole.
 */
export async function listPracticeIntakeProviders(
  medplum: MedplumClient,
  organizationId: string,
): Promise<MockProvider[]> {
  const practitioners = await medplum.searchResources('Practitioner', {
    _count: '500',
  });

  return practitioners
    .filter(
      (p) =>
        p.id &&
        p.active !== false &&
        practitionerBelongsToOrganization(p, organizationId) &&
        isProviderRole(p),
    )
    .map(practitionerToIntakeProvider)
    .sort((a, b) => a.name.localeCompare(b.name));
}
